import React from 'react'
import PropTypes from 'prop-types'
import { getOptimizedImagePath } from '@abillionveg/abillionutilities'
import { getResolutionFromImageSize } from '../../lib/format'

const OptimizedImage = React.forwardRef((props, ref) => {
  const { src, size } = props

  let optimizedPath = src

  if (size) {
    const optimizedWidth = getResolutionFromImageSize(size)
    optimizedPath = getOptimizedImagePath(src, optimizedWidth)
  }

  return <img ref={ref} {...props} src={optimizedPath} />
})

OptimizedImage.displayName = 'OptimizedImage'

OptimizedImage.propTypes = {
  src: PropTypes.string.isRequired,
  size: PropTypes.string
}

export default OptimizedImage
